import { render } from "./client-accounts.vue?vue&type=template&id=b07ea8ae"
import script from "./client-accounts.vue?vue&type=script&lang=js"
export * from "./client-accounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__